export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: 10,
  },
  fileUpload: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0,
  },
  hint: {
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
  },
  dropzone: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 2,
    borderColor: 'rgb(102, 102, 102)',
    borderStyle: 'dashed',
    borderRadius: 20,
    padding: 20,
    margin: 10,
  },
  dropzoneActive: {
    flex: 1,
    flexDirection: 'row',
    borderWidth: 2,
    borderColor: 'green', // 'rgb(0, 200, 200)',
    borderStyle: 'solid',
    borderRadius: 20,
    padding: 20,
    margin: 10,
  },
  // csv: {
  //   display: 'flex',
  //   flexDirection: 'row',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //
  // },
  uploadInstructions: {
    textAlign: 'center',
    verticalAlign: 'center',
    margin: 10,
    flex: 1,
  },
  csvInfo: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
  },
  csvProperties: {
    // display: 'flex',
    // flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto',
  },
  tasksInfo: {
    textAlign: 'center',
    margin: 5,
  },
  taskCount: {
    margin: 20,
    fontSize: 72,
  },
  actionCol: {
    width: 50,
  },
};



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskUploadDialog/styles.js